// extracted by mini-css-extract-plugin
export var assigneeBadge = "_l4-0";
export var assigneeDetails = "_l4-1";
export var assigneeInfo = "_l4-2";
export var dropdownContainer = "_l4-4";
export var dropdownImage = "_l4-5";
export var editAssigneeInfo = "_l4-3";
export var editAssigneeModalContainer = "_l4-6";
export var hidden = "_l4-8";
export var input = "_l4-7";